export function formatCurrency(number?: number | null): string {
  if (!number) {
    return '$0.00';
  }
  const numberStr = number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return number < 0 ? `-$${numberStr.slice(1)}` : `$${numberStr}`;
}
